import { useGetCommunityBySlug } from '@sunrise-ui/api-client';
import { withAuthGate } from '@sunrise-ui/composites';
import { isNative } from '@sunrise-ui/primitives';
import CommunityMetaTags from '@templates/CommunityMetaTags';
import CommunityView from '@templates/CommunityView';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

function CommunityPage() {
  const { communitySlug } = useLocalSearchParams<{
    communitySlug: string;
  }>();
  const { data: community } = useGetCommunityBySlug(communitySlug);

  return (
    <>
      <CommunityMetaTags
        communityName={community?.name}
        communityDescription={community?.bio}
        communitySlug={communitySlug}
      />
      <CommunityView communitySlug={communitySlug} />
    </>
  );
}

export default withAuthGate(CommunityPage, { requireAuth: isNative });
